import { render, staticRenderFns } from "./PractitionerMonitoring.vue?vue&type=template&id=552d29a1&"
import script from "./PractitionerMonitoring.vue?vue&type=script&lang=js&"
export * from "./PractitionerMonitoring.vue?vue&type=script&lang=js&"
import style0 from "./PractitionerMonitoring.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports